declare namespace $ {

	type $mol_hotkey2__action_giper_baza_rich_edit_1 = $mol_type_enforce<
		({ 
			alt_S( next?: ReturnType< $giper_baza_rich_edit['inline_toggle'] > ): ReturnType< $giper_baza_rich_edit['inline_toggle'] >,
			alt_E( next?: ReturnType< $giper_baza_rich_edit['inline_toggle'] > ): ReturnType< $giper_baza_rich_edit['inline_toggle'] >,
			alt_I( next?: ReturnType< $giper_baza_rich_edit['inline_toggle'] > ): ReturnType< $giper_baza_rich_edit['inline_toggle'] >,
			alt_R( next?: ReturnType< $giper_baza_rich_edit['inline_toggle'] > ): ReturnType< $giper_baza_rich_edit['inline_toggle'] >,
			alt_C( next?: ReturnType< $giper_baza_rich_edit['inline_toggle'] > ): ReturnType< $giper_baza_rich_edit['inline_toggle'] >,
			alt_T( next?: ReturnType< $giper_baza_rich_edit['block_wrap'] > ): ReturnType< $giper_baza_rich_edit['block_wrap'] >,
			alt_Q( next?: ReturnType< $giper_baza_rich_edit['block_wrap'] > ): ReturnType< $giper_baza_rich_edit['block_wrap'] >,
			alt_U( next?: ReturnType< $giper_baza_rich_edit['block_wrap'] > ): ReturnType< $giper_baza_rich_edit['block_wrap'] >,
			alt_O( next?: ReturnType< $giper_baza_rich_edit['block_wrap'] > ): ReturnType< $giper_baza_rich_edit['block_wrap'] >,
			alt_P( next?: ReturnType< $giper_baza_rich_edit['block_wrap'] > ): ReturnType< $giper_baza_rich_edit['block_wrap'] >,
			tab( next?: ReturnType< $giper_baza_rich_edit['block_rewrap'] > ): ReturnType< $giper_baza_rich_edit['block_rewrap'] >,
			shift_tab( next?: ReturnType< $giper_baza_rich_edit['block_unwrap'] > ): ReturnType< $giper_baza_rich_edit['block_unwrap'] >,
			ctrl_Z( next?: ReturnType< $giper_baza_rich_edit['undo'] > ): ReturnType< $giper_baza_rich_edit['undo'] >,
			ctrl_shift_Z( next?: ReturnType< $giper_baza_rich_edit['redo'] > ): ReturnType< $giper_baza_rich_edit['redo'] >,
		}) 
		,
		ReturnType< $mol_hotkey2['action'] >
	>
	type $mol_button_minor__hint_giper_baza_rich_edit_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_giper_baza_rich_edit_3 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['selected'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_giper_baza_rich_edit_4 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['block_unwrap'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_giper_baza_rich_edit_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_giper_baza_rich_edit_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_giper_baza_rich_edit_7 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['selected'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_giper_baza_rich_edit_8 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['block_wrap'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_giper_baza_rich_edit_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_giper_baza_rich_edit_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_giper_baza_rich_edit_11 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['selected'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_giper_baza_rich_edit_12 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['block_wrap'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_giper_baza_rich_edit_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_giper_baza_rich_edit_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_giper_baza_rich_edit_15 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['selected'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_giper_baza_rich_edit_16 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['block_wrap'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_giper_baza_rich_edit_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_giper_baza_rich_edit_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_giper_baza_rich_edit_19 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['selected'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_giper_baza_rich_edit_20 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['block_wrap'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_giper_baza_rich_edit_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_giper_baza_rich_edit_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_giper_baza_rich_edit_23 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['selected'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_giper_baza_rich_edit_24 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['block_wrap'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_giper_baza_rich_edit_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__title_giper_baza_rich_edit_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_giper_baza_rich_edit_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_giper_baza_rich_edit_28 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['selected'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_giper_baza_rich_edit_29 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['inline_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_giper_baza_rich_edit_30 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_giper_baza_rich_edit_31 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_giper_baza_rich_edit_32 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['selected'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_giper_baza_rich_edit_33 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['inline_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_giper_baza_rich_edit_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_giper_baza_rich_edit_35 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_giper_baza_rich_edit_36 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['selected'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_giper_baza_rich_edit_37 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['inline_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_giper_baza_rich_edit_38 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_giper_baza_rich_edit_39 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_giper_baza_rich_edit_40 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['selected'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_giper_baza_rich_edit_41 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['inline_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_giper_baza_rich_edit_42 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__hint_giper_baza_rich_edit_43 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_giper_baza_rich_edit_44 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['selected'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_giper_baza_rich_edit_45 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['inline_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_pick__hint_giper_baza_rich_edit_46 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__trigger_enabled_giper_baza_rich_edit_47 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['selected'] >
		,
		ReturnType< $mol_pick['trigger_enabled'] >
	>
	type $mol_pick__trigger_content_giper_baza_rich_edit_48 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_giper_baza_rich_edit_49 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_bar__sub_giper_baza_rich_edit_50 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_bar['sub'] >
	>
	type $mol_string__hint_giper_baza_rich_edit_51 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__hint_giper_baza_rich_edit_52 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_bar__sub_giper_baza_rich_edit_53 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_bar['sub'] >
	>
	type $mol_float__sub_giper_baza_rich_edit_54 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['tools'] >
		,
		ReturnType< $mol_float['sub'] >
	>
	type $mol_view__attr_giper_baza_rich_edit_55 = $mol_type_enforce<
		({ 
			'contenteditable': ReturnType< $giper_baza_rich_edit['editable'] >,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__event_giper_baza_rich_edit_56 = $mol_type_enforce<
		({ 
			input( next?: ReturnType< $giper_baza_rich_edit['save'] > ): ReturnType< $giper_baza_rich_edit['save'] >,
			paste( next?: ReturnType< $giper_baza_rich_edit['paste'] > ): ReturnType< $giper_baza_rich_edit['paste'] >,
			pointermove( next?: ReturnType< $giper_baza_rich_edit['hover'] > ): ReturnType< $giper_baza_rich_edit['hover'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_giper_baza_rich_edit_57 = $mol_type_enforce<
		ReturnType< $giper_baza_rich_edit['content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $giper_baza_rich_edit extends $mol_view {
		enabled( ): boolean
		selection_load( ): any
		selection_sync( ): any
		inline_toggle( id: any, next?: any ): any
		block_wrap( id: any, next?: any ): any
		block_rewrap( next?: any ): any
		block_unwrap( next?: any ): any
		undo( next?: any ): any
		redo( next?: any ): any
		Hotkey( ): $mol_hotkey2
		selected( next?: boolean ): boolean
		Unwrap_icon( ): $mol_icon_arrow_collapse_left
		Unwrap_button( ): $mol_button_minor
		Section_icon( ): $mol_icon_format_size
		Section_button( ): $mol_button_minor
		List_bullet_icon( ): $mol_icon_order_bool_ascending
		List_bullet_button( ): $mol_button_minor
		List_number_icon( ): $mol_icon_order_numeric_ascending
		List_number_button( ): $mol_button_minor
		Quote_icon( ): $mol_icon_comment_quote_outline
		Quote_button( ): $mol_button_minor
		Preformat_icon( ): $mol_icon_xml
		Preformat_button( ): $mol_button_minor
		Inline_format_menu_icon( ): $mol_icon_marker
		Strong_button( ): $mol_button_minor
		Em_button( ): $mol_button_minor
		Ins_button( ): $mol_button_minor
		Del_button( ): $mol_button_minor
		Code_button( ): $mol_button_minor
		Inline_format_menu( ): $mol_pick
		Main( ): $mol_bar
		Search_query( ): $mol_string
		Search_replace( ): $mol_string
		Search_panel( ): $mol_bar
		tools( ): readonly(any)[]
		Tools( ): $mol_float
		editable( next?: string ): string
		save( next?: any ): any
		paste( next?: any ): any
		hover( next?: any ): any
		content( ): readonly(any)[]
		Content( ): $mol_view
		pawn( next?: $giper_baza_rich ): $giper_baza_rich
		attr( ): ({ 
			'giper_baza_rich_edit_enabled': ReturnType< $giper_baza_rich_edit['enabled'] >,
		})  & ReturnType< $mol_view['attr'] >
		hint( ): string
		auto( ): readonly(any)[]
		plugins( ): readonly(any)[]
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=edit.view.tree.d.ts.map